import { signalRService } from './signalRService';
import { getLocalInfo } from 'src/utils/encrypt';

class KeepAliveService {
  private keepAliveInterval: NodeJS.Timeout | null = null;
  private readonly keepAliveIntervalMs = 25000; 
  public startKeepAlive(): void {
    if (this.keepAliveInterval) {
      this.stopKeepAlive();
    }

    this.keepAliveInterval = setInterval(async () => {
      try {
        if (signalRService.isConnected()) {
          await signalRService.sendKeepAlive();
          console.debug('Keep-alive ping sent successfully');
        } else {
          console.warn('SignalR not connected, attempting to reconnect...');
          const accessToken = getLocalInfo('accessToken');
          if (accessToken) {
            await signalRService.connect();
          } else {
            console.warn('No access token available, cannot reconnect SignalR');
          }
        }
      } catch (error) {
        console.error('Keep-alive failed:', error);
        try {
          const accessToken = getLocalInfo('accessToken');
          if (accessToken && !signalRService.isConnected()) {
            await signalRService.connect();
          }
        } catch (reconnectError) {
          console.error('Reconnection attempt failed:', reconnectError);
        }
      }
    }, this.keepAliveIntervalMs);

  }

  public stopKeepAlive(): void {
    if (this.keepAliveInterval) {
      clearInterval(this.keepAliveInterval);
      this.keepAliveInterval = null;
    }
  }

  public isRunning(): boolean {
    return this.keepAliveInterval !== null;
  }
}

export const keepAliveService = new KeepAliveService();
